import { apiRequest } from "../_core/apiRequest";
import { getAuthHeaders } from "../_core/authHeaders";

async function getAccountSelectionHeaders() {
  const headers = await getAuthHeaders();

  return {
    ...headers,
    Authorization: headers.Client_ID,
  };
}

export async function listAuthAccounts() {
  const headers = await getAccountSelectionHeaders();

  return apiRequest({
    method: "GET",
    path: "/auth/accounts",
    auth: false,
    headers,
    errorMessage: "Não foi possível carregar suas contas.",
  });
}

export async function selectAuthAccount(accountId) {
  const headers = await getAccountSelectionHeaders();

  return apiRequest({
    method: "POST",
    path: "/auth/accounts/select",
    data: { account_id: accountId },
    auth: false,
    headers,
    errorMessage: "Não foi possível acessar esta conta.",
  });
}
